import React from "react";
import {
    DOCS_UI_URL,
    ETICKET_UI_URL,
    GRANT_UI_URL,
    LICENSE_UI_URL,
    RESEARCH_UI_URL,
    SECURITY_UI_URL,
} from "../../../constants/config.constant";

const MyAppsMenu = (
    user,
    isPermissionLoaded,
    hasPermission,
    lang,
    getLangUrl,
    getAdminLangUrl
) => (
    <div className="profile-menu-list">
        {isPermissionLoaded && hasPermission("common:myComponent:security") && (
            <div className="profile-menu-item">
                <a href={`${SECURITY_UI_URL}/admin`} target={"_blank"}>
                    User Access & Common Configuration
                </a>
            </div>
        )}
        {isPermissionLoaded && hasPermission("common:myComponent:grant") && (
            <div className="profile-menu-item">
                <a href={`${GRANT_UI_URL}/admin`}>Grant/Fellowship</a>
            </div>
        )}
        {isPermissionLoaded && hasPermission("common:myComponent:license") && (
            <div className="profile-menu-item">
                <a href={`${LICENSE_UI_URL}/admin`}>Licensing/Permit/NOC</a>
            </div>
        )}
        {isPermissionLoaded && hasPermission("common:myComponent:eTicket") && (
            <div className="profile-menu-item">
                <a href={`${ETICKET_UI_URL}/admin`}>
                    e-Ticketing & Virtual Gallery
                </a>
            </div>
        )}
        {isPermissionLoaded && hasPermission("common:myComponent:research") && (
            <div className="profile-menu-item">
                <a href={`${RESEARCH_UI_URL}/admin`}>
                    Research Articles & Journals
                </a>
            </div>
        )}
        {isPermissionLoaded && hasPermission("common:myComponent:library") && (
            <div className="profile-menu-item">
                <a href={`${RESEARCH_UI_URL}/admin`}>Library</a>
            </div>
        )}
        {isPermissionLoaded && hasPermission("common:myComponent:training") && (
            <div className="profile-menu-item">
                <a href={`${RESEARCH_UI_URL}/admin`}>Training & e-Learning</a>
            </div>
        )}
        {isPermissionLoaded &&
            hasPermission("common:myComponent:Accommodation") && (
                <div className="profile-menu-item">
                    <a href={`${RESEARCH_UI_URL}/admin`}>
                        Online Accommodation
                    </a>
                </div>
            )}
        {isPermissionLoaded && hasPermission("common:myComponent:grant") && (
            <div className="profile-menu-item">
                <a href={`${DOCS_UI_URL}/admin`}>Docs</a>
            </div>
        )}
    </div>
);

export default MyAppsMenu;
